import React, { useState, useEffect } from 'react';

//* Translations
import strings from 'translations/strings.json';

//* Components
import CartTable from './components/CartTable/CartTable';

//* Styles
import styles from './CartView.module.scss';

const MAIN_DOMAIN = "https://filotrack.com"

const CartView = ({ cart, setCart, wcCart }) => {

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

    const [ cartItems, setCartItems ] = useState([])

    useEffect(() => {

        if(cart !== undefined && cart !== null){

            const existing_cart_array = Object.values(cart)

            setCartItems(existing_cart_array)

        }

        /* eslint-disable-next-line */
    }, [cart])

    function backToShopping(){
        let PATH_LANG = LANG === "en" ? "" : `/${LANG}`

        let url = `${MAIN_DOMAIN}${PATH_LANG}/react-filo-tag`

        window.location.href = url
    }
    

  return (
    <div className={styles["cart-view"]}>
        <h1 className={styles["cart-title"]}>{STRINGS_LANG.your_cart}</h1>
        {
            cartItems.length === 0 ?
            <div className={styles["empty-cart"]}>
                <p className={styles["label"]}>{STRINGS_LANG.empty_cart}</p>
                <p className={styles["back-link"]}
                    onClick={() => backToShopping()}
                >{STRINGS_LANG.back_to_shopping}</p>
            </div> : <CartTable cart={cart} setCart={setCart} wcCart={wcCart} />
        }
    </div>
  )
}

export default CartView